var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.113 19.089a1.5 1.5 0 01.318-.47l12.021-12.02a2.5 2.5 0 013.535 0l1.415 1.413a2.5 2.5 0 010 3.536L13.38 23.568a1.499 1.499 0 01-.47.319l-4.95 2.121a1.5 1.5 0 01-1.97-1.97l2.122-4.95zm3.465 3.737l-2.404-2.404L7.37 24.63l4.207-1.803zM19.922 9.25l2.828 2.828 1.591-1.59a1 1 0 000-1.415L22.927 7.66a1 1 0 00-1.414 0l-1.591 1.59zm-1.061 1.06l-8.839 8.84 2.829 2.828 8.838-8.839-2.828-2.829z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit32);
export default __webpack_public_path__ + "static/media/icon-edit-32.05a855f2.svg";
export { ForwardRef as ReactComponent };